'use strict';
import axios from "axios";
import Configuration from "@/Common/Configuration";
import Utility from "@/Common/Utility";



let VirtualDirectory = "";;

if (typeof (AppSettings) != "undefined" && typeof (AppSettings) == "object") {

    if (AppSettings.VirtualDirectory != null && AppSettings.VirtualDirectory != "") {
        VirtualDirectory = "/" + AppSettings.VirtualDirectory;
    }
    else {
        VirtualDirectory = "";
    }
}

var ApiService = {

    LastPostUrl: "",
    LastServerError: "",

    Query(dataName, requestObj) {
        let resultPromise;
        let url;

        //url = Configuration.BaseUrl + "api/" + dataName + "/Get";
        url = Utility.GetBaseUrl() + "api/" + dataName + "/Get";

        if (requestObj == null) {
            requestObj = {};
        }

        resultPromise = this.Get(url, requestObj);

        return resultPromise;
    }
    ,

    Get: function (url, arg) {
        var resultPromise;

        if (url.indexOf("http") < 0) {
            //url = Configuration.BaseUrl + url;
            url = Utility.GetBaseUrl() + url;
        }


        resultPromise = new Promise(
            (resolve, reject) => {
                axios
                    .post(
                        url,
                        arg
                    )
                    .then(response => {


                        Utility.ProcessIso8601Text(null, response.data);


                        resolve(response.data);
                    })
                    .catch(
                        (err) => {
                            alert("error : " + err);
                            reject(err);
                        }
                    );
            }
        );

        return resultPromise;
    } //end Get: function (url,params) {
    ,


    //用於新增
    Post: function (url, arg, wrapRequest) {
        let resultPromise;
        let systemUserJson, systemUser;
        let matchTokens;
        let branchNo;
        let bags = [];
        let i;


        if (wrapRequest == null) {
            wrapRequest = true;
        }

        if (arg == null) {
            arg = {};
        }

        if (url.indexOf("http") < 0) {
            //url = Configuration.BaseUrl + url;



            if (window.location.href.indexOf("localhost:808") < 0) {

                if (window.location.href.indexOf("localhost") > 0 &&
                    window.location.href.indexOf(":808") < 0) {
                    url = Utility.GetBaseUrl() +
                        url;
                }
                else {
                    url = Utility.GetBaseUrl() +
                        VirtualDirectory +
                        url;
                }
            }
            else {
                url = Utility.GetBaseUrl() +
                    url;
            }
        }


        if (url.indexOf("Query") < 0 && url.indexOf("Detail") < 0) {
            Utility.OnDataModify();
        }

        bags = Utility.GetAllBags();


        if (arg != null && typeof (arg) == "object") {
            arg.Bag = {};

            for (i = 0; i < bags.length; i++) {
                arg.Bag[bags[i].Name] = bags[i].Value;
            }

            Utility.ProcessResponseData(arg);
        }

        if (arg != null && typeof (arg) == "object") {
            //PROBLEM
            if (arg.Bag.DataLanguage == null || arg.Bag.DataLanguage == "") {
                arg.Bag.DataLanguage = "ZH_TW";
            }

            //PROBLEM
            if (arg.Bag.BackendDataLanguage == null || arg.Bag.BackendDataLanguage == "") {
                arg.Bag.BackendDataLanguage = "ZH_TW";
            }
        }


        this.LastPostUrl = url;

        if (arg.SelectedRows != null) {
            arg.SelectedRowsFromRequest = arg.SelectedRows;
        }
 

         
        resultPromise = new Promise(
            (resolve, reject) => {
                axios
                    .post(
                        url,
                        wrapRequest ? { RequestData: arg } : arg
                    )
                    .then(response => {

                        this.LastServerError = "";



                        if (response.data != null && typeof (response.data) == "object") {
                            response.data.CreateTime = new Date();
                        }

                        Utility.ProcessIso8601Text(null, response.data.d);



                        resolve(response.data.d);
                    })
                    .catch(
                        (err) => {
                            if (err.response == null) {
                                if (this.LastServerError != (err + "")) {
                                    Utility.ShowServerError(err);

                                    this.LastServerError = err + "";
                                }
                            }
                            else {
                                if (err.response.data != null && err.response.data.errors != null) {
                                    let keyName;
                                    keyName = Object.keys(err.response.data.errors)[0];
                                    Utility.ShowServerError(
                                        err.response.data.title + "\r\n" +
                                        err.response.data.errors[keyName]
                                    );
                                }
                                else {
                                    if (this.LastServerError != (err.response.data + "")) {

                                        if (
                                            err.response.data != null &&
                                            typeof (err.response.data)
                                        ) {
                                            let errorMessage = "";

                                            for (var em in err.response.data) {
                                                errorMessage += err.response.data[em] + "\r\n";
                                            }

                                            Utility.ShowServerError(errorMessage);

                                            this.LastServerError = errorMessage;
                                        }
                                        else {
                                            Utility.ShowServerError(err.response.data);
                                            this.LastServerError = (err.response.data + "");
                                        }

                                    }
                                }
                            }

                            reject(err);
                        }
                    );
            }

        );

        //let requestJson = "{ \"RequestData\" : " + JSON.stringify(arg) + " }";
        //resultPromise = new Promise(
        //    (resolve, reject) => {
        //        $.ajax({
        //            type: "POST",
        //            "url": url,
        //            data: requestJson,
        //            contentType: "application/json; charset=utf-8",
        //            dataType: "json",
        //            async: "true",
        //            cache: "false",
        //            success: function (response) {
        //                Utility.ProcessResponseData(response.d);

        //                response.d.CreateTime = new Date();

        //                return resolve(response.d);
        //            },
        //            error: function (xmlHttpDoc, e, errorThrown) {
        //                let serverErrorObj;
        //                let serverErrorMessage;

        //                if (xmlHttpDoc.responseText != "") {
        //                    try {
        //                        serverErrorObj = JSON.parse(xmlHttpDoc.responseText);
        //                        serverErrorMessage = serverErrorObj.Message + "\r\n" +
        //                            serverErrorObj.StackTrace;

        //                        Utility.ShowServerError(serverErrorMessage);
        //                    }
        //                    catch (ex) {
        //                        Utility.ShowServerError(xmlHttpDoc.responseText);
        //                    }
        //                }
        //                else {
        //                    Utility.ShowServerError(e + "");
        //                }

        //                return reject(e);
        //            }
        //        }
        //        )
        //    }
        //);



        return resultPromise;
    }//end Post: function (url, params) {

    ,


    ServerPost(url, arg) {
        let serverPostRequest = {
        };


        serverPostRequest.Url = url;
        serverPostRequest.RequestJson = JSON.stringify(arg);

        return this.Post(
            "/Controllers/ServerWebRequestController.aspx/Post",
            serverPostRequest
        ).then(
            function (responseData) {

                if (responseData.Success) {
                    let responseObject;

                    responseObject = JSON.parse(responseData.ResponseJson);

                    return Promise.resolve(responseObject);
                }
                else {
                    Utility.ShowServerError(responseData.Message + "\r\n\r\n" + responseData.ResponseText);

                    return Promise.resolve(null);
                }
            }.bind(this)
        );
    },


    ServerGet(url) {
        let serverPostRequest = {
        };


        serverPostRequest.Url = url;
        serverPostRequest.RequestJson = JSON.stringify(arg);

        return this.Post(
            "/Controllers/ServerWebRequestController.aspx/Get",
            serverPostRequest
        ).then(
            function (responseData) {

                if (responseData.Success) {
                    let responseObject;

                    responseObject = JSON.parse(responseData.ResponseJson);

                    return Promise.resolve(responseObject);
                }
                else {
                    return Promise.resolve(null);
                }
            }.bind(this)
        );
    },



    ServerGetHtml(url) {
        let serverPostRequest = {
        };


        serverPostRequest.Url = url;

        return this.Post(
            "/Controllers/ServerWebRequestController.aspx/Get",
            serverPostRequest
        ).then(
            function (responseData) {

                if (responseData.Success) {
                    return Promise.resolve(responseData.ResponseJson);
                }
                else {
                    return Promise.resolve(null);
                }
            }.bind(this)
        );
    },//end ServerGetHtml(url) {


    Put: function (url, params) {
        var resultPromise;

        resultPromise = new Promise(
            (resolve, reject) => {

                axios
                    .put(url, {
                        params: params
                    })
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(
                        (err) => {
                            alert("error : " + err);
                            reject(err);
                        }
                    );
            }
        );

        return resultPromise;
    }//end Put : function (url, params) {

    ,

    Delete: function (url, params) {
        var resultPromise;

        resultPromise = new Promise(
            (resolve, reject) => {

                axios
                    .delete(url, {
                        params: params
                    })
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(
                        (err) => {
                            alert("error : " + err);
                            reject(err);
                        }
                    );
            }
        );

        return resultPromise;
    }//end Delete: function (url, params) {

    ,

    install(Vue, options) {

        Object.defineProperty(Vue.prototype,
            '$api',
            {
                get() {
                    if (this.$_api == null) {
                        this.$_api = ApiService;
                    }
                    return this.$_api;
                }
            }
        );
    },

}


class Option {
    FieldName = "";
    FieldValue = "";
}


export default ApiService;

